import { headerConnect as connect } from 'components/Shared/connect';
import { IMenuItem } from 'models/IMenuItem';
import { SubCategories } from './subcategories';
import cn from 'classnames';
import styles from './styles.scss';
import {
  closeMenu,
  closeMainMenu,
  openMenu,
  openMainMenu,
  isMenuOpen
} from 'components/MainMenu/actions';
import { delay } from 'utils';
import { isAllCategoriesMenuItem } from 'components/MainMenu/selectors';

const delayMenuToggle = delay();

interface MergedProps extends IMenuItem {
  selected: boolean;
  closeMenu: () => void;
  openMenu: () => void;
}

const DesktopMenuItem = ({
  id,
  url,
  title,
  subCategories,
  closeMenu,
  openMenu,
  selected
}: MergedProps) => {
  const hasChildren = subCategories && subCategories.length > 0;
  const allCategories = isAllCategoriesMenuItem(id);
  const displaySubCategories = hasChildren && selected;
  return (
    <li
      onMouseOver={openMenu}
      onMouseLeave={closeMenu}
      className={cn({
        [styles.selected]: selected,
        [styles.showSelectedMarker]: displaySubCategories
      })}
    >
      <a data-argtgrp={id} href={url}>
        {title}
      </a>
      {displaySubCategories && <SubCategories {...{ subCategories, allCategories }} />}
    </li>
  );
};

export default connect<MergedProps, IMenuItem>(
  ({ header: { mainMenu } }, props: IMenuItem) => ({
    selected: isMenuOpen(mainMenu, props)
  }),
  (dispatch, { id }: IMenuItem) => ({
    closeMenu: () =>
      delayMenuToggle.setDelay(() => {
        dispatch(closeMenu({ parents: [], target: id }));
        dispatch(closeMainMenu());
      }),
    openMenu: () =>
      delayMenuToggle.setDelay(() => {
        dispatch(openMenu({ parents: [], target: id }));
        dispatch(openMainMenu());
      })
  })
)(DesktopMenuItem);
